import ctaImg from '../../assets/images/earnings.png';
import bigLogo from '../../assets/images/logo-white.svg';
import playStoreImg from '../../assets/images/play_store_white.svg';
import appStoreImg from '../../assets/images/app_store_white.svg';

import ServiceButton from '../ui/ServiceButton';
import { useSmoothScroll } from '../../hooks/useSmoothScroll';

import { FaInstagram, FaFacebookF, FaLinkedinIn } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";

function DeliverFooter() {
  const { scrollToSection } = useSmoothScroll();

  // Use real Speedyssey social links
  const socialLinks = [
    { icon: <FaInstagram />, href: 'https://www.instagram.com/speedysseydelivery/' },
    { icon: <FaFacebookF />, href: 'https://www.facebook.com/my.speedyssey' },
    { icon: <FaXTwitter />, href: 'https://x.com/speedyssey' },
    { icon: <FaLinkedinIn />, href: 'https://www.linkedin.com/company/speedyssey/?viewAsMember=true' },
  ];

  const handleDownload = () => {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/android/i.test(userAgent)) {
      window.open(
        "https://play.google.com/store/apps/details?id=com.dp.speedyssey",
        "_blank",
      );
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      window.open("https://apps.apple.com/app/speedyssey", "_blank");
    } else {
      // Desktop fallback
       window.open(
         "https://play.google.com/store/apps/details?id=com.dp.speedyssey",
         "_blank",
       );
    }
  };
  return (
    <footer className="w-full">
      {/* CTA Banner */}
      <section
        className="relative h-96 flex items-center justify-center text-center"
        style={{
          backgroundImage: `url(${ctaImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="relative z-10 space-y-6 px-6 flex flex-col items-center justify-center w-full">
          <h2 className="text-white special text-3xl md:text-5xl font-bold">
            Ready to start earning?
          </h2>
          <p className="text-white/90 md:text-lg max-w-xl mx-auto">
            Join hundreds of delivery partners already making moves with Speedyssey.
          </p>
          {/* Mobile: Show two store buttons, Desktop: Show single ServiceButton */}
          <div className="w-full">
            {/* Mobile (smaller than md): flex, md+: hidden */}
            <div className="flex flex-col justify-center gap-3 md:hidden w-full">
              <a
                href="https://play.google.com/store/apps/details?id=com.dp.speedyssey"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full block"
              >
                <img
                  src={playStoreImg}
                  alt="Get it on Google Play"
                  className="h-12 w-full object-contain"
                  style={{ maxWidth: '100%' }}
                />
              </a>
              <a
                href="https://apps.apple.com/app/speedyssey/id6448916710"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full block"
              >
                <img
                  src={appStoreImg}
                  alt="Download on the App Store"
                  className="h-12 w-full object-contain"
                  style={{ maxWidth: '100%' }}
                />
              </a>
            </div>
            {/* Desktop (md+): show ServiceButton */}
            <div className="hidden md:flex justify-center w-full">
              <ServiceButton title="Download App" variant="orange" onClick={handleDownload} />
            </div>
          </div>
        </div>
      </section>

      {/* Main Footer */}
      <section className="bg-[#1A1A1A] text-white pt-16 px-6 pb-12 lg:px-12">
        <div className="container mx-auto flex flex-col md:flex-row md:items-end md:justify-between gap-12">
          {/* Left: Logo, description, social, copyright */}
          <div className="flex flex-col justify-between h-full md:min-h-[220px]">
            <div>
              <img src={bigLogo} alt="Speedyssey" className="h-16 w-auto mb-4" />
              <p className=" text-gray-400 max-w-lg mb-6">
                Delivering opportunities. Powered by people, driven by logistics.
              </p>
            </div>
            <div className="flex flex-col gap-4">
              <div className="flex space-x-4 mb-2">
                {socialLinks.map((link, index) => (
                  <a
                    key={index}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-white transition-colors duration-300 w-6 h-6 flex items-center justify-center text-lg"
                  >
                    {link.icon}
                  </a>
                ))}
              </div>
              <div className=" text-gray-500 text-left mt-2">
                © 2025 Speedyssey. All right reserved.
              </div>
            </div>
          </div>

          {/* Right: Links */}
          <div className="flex flex-col md:flex-row md:items-start md:justify-end gap-16 w-full md:w-auto">
            {/* Quick Links */}
            <div className="text-left w-full md:w-auto">
              <h4 className="text-gray-300 font-semibold mb-6 tracking-wider text-lg special-header">QUICK LINKS</h4>
              <ul className="flex flex-col gap-5 text-gray-400">
                <li>
                  <button onClick={() => scrollToSection('how')} className="hover:text-white text-left">How It Works</button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('requirements')} className="hover:text-white text-left">Requirements</button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('overview')} className="hover:text-white text-left">About Speedyssey</button>
                </li>
                <li>
                  <a href="/services" className="hover:text-white">For Business Owners</a>
                </li>
              </ul>
            </div>

            {/* Resources */}
            <div className="text-left w-full md:w-auto">
              <h4 className="text-gray-300 font-semibold mb-6 tracking-wider text-lg special-header">RESOURCES</h4>
              <ul className="flex flex-col gap-5 text-gray-400">
                <li>
                  <button onClick={() => scrollToSection('faqs')} className="hover:text-white text-left">FAQs</button>
                </li>
                <li>
                  <a href="/privacy-policy" className="hover:text-white">Privacy Policy</a>
                </li>
                <li>
                  <a href="/terms-conditions" className="hover:text-white">Terms & Conditions</a>
                </li>
                <li>
                  <a href="/terms-conditions" className="hover:text-white">Driver Code of Conduct</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
}

export default DeliverFooter;
